import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { campaignQueries } from '@/entities/campaign'

type Props = {
  page: number
  pageType: 'host' | 'guest'
  categoryId: number | null
}

export const useArticles = ({ page, pageType, categoryId }: Props) => {
  const { data } = useQuery({
    ...campaignQueries.articlesList({
      page,
      onlyGuestArticle: pageType === 'guest',
      onlyHostArticle: pageType === 'host',
      ...(categoryId && { categoryId }),
    }),
    placeholderData: keepPreviousData,
    meta: {
      useCustomHandling: true,
    },
  })

  const articles = data?.articles?.content ?? []
  const lastPage = data?.articles?.lastPage ?? 1
  const articleCategories = data?.articleCategories ?? []

  return {
    lastPage,
    articles,
    articleCategories,
  }
}
